/**
 * Hook to get current user ID for filtering user-owned resources
 */
import { useAuthStore } from "@/stores/authStore"

export function useCurrentUser() {
  const user = useAuthStore((state) => state.user)
  return {
    userId: user?.id ?? null,
    user,
  }
}
